import React, { Component, PropTypes } from 'react';
import { autobind } from 'core-decorators';
import classNames from 'classnames';

import { byIdShape } from 'utils/propTypes';

import Loader from 'AppComponents/Loader';

import Charger from './components/Charger';

import './styles.scss';


class ChargerList extends Component {

  static propTypes = {
    chargers: PropTypes.arrayOf(PropTypes.number).isRequired,
    chargersById: byIdShape.isRequired,
    hoveredCharger: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loading: PropTypes.bool,
    onChargerMouseEnter: PropTypes.func,
    onChargerMouseLeave: PropTypes.func,
    onLoadMore: PropTypes.func,
    selectedCharger: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    hoveredCharger: null,
    loading: false,
    onChargerMouseEnter: () => {},
    onChargerMouseLeave: () => {},
    onLoadMore: () => {},
    selectedCharger: null,
  };

  constructor(props, context) {
    super(props, context);
    this._ignoreScroll = false;
  }

  componentDidMount() {
    this.setSizes();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.chargers.length !== this.props.chargers.length ||
      (!nextProps.loading && this.props.loading !== nextProps.loading)
    ) {
      this._ignoreScroll = false;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chargers !== this.props.chargers) {
      this.setSizes();
    }
  }

  setSizes() {
    this.listRect = this.list.getBoundingClientRect();
    this.wrapperRect = this.wrapper.getBoundingClientRect();
  }

  @autobind
  handleScroll(e) {
    if (!this._ignoreScroll) {
      const scrollThreshold = 200;
      const scroll = e.target.scrollTop;
      const outOfView = this.listRect.height - this.wrapperRect.height;
      const distanceFromBottom = outOfView - scroll;
      if (distanceFromBottom < scrollThreshold) {
        this.props.onLoadMore();
        this._ignoreScroll = true;
      }
    }
  }

  render() {
    const { chargers, selectedCharger, hoveredCharger, chargersById, loading } = this.props;
    return (
      <div
        className={classNames('charger-list', { loading })}
        styleName='charger-list'
      >
        <div styleName='scroll-wrapper' ref={(c) => { this.wrapper = c; }} onScroll={this.handleScroll}>
          <div ref={(c) => { this.list = c; }} className='list-group'>
            { chargers.filter(id => !!chargersById[id]).map(id => (
              <Charger
                charger={chargersById[id]}
                key={id}
                selected={selectedCharger === id}
                hovered={hoveredCharger === id}
                onMouseEnter={e => this.props.onChargerMouseEnter(id, e)}
                onMouseLeave={e => this.props.onChargerMouseLeave(id, e)}
              />
            ))}

            <div styleName='loading-item'>
              <Loader />
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default ChargerList;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Home/components/ChargerList/index.jsx